export const schemeRoutes = {
  GET_SCHEME: "/club/schema",
}